const printerPaths = {
  SEARCH_PRINTER: "search",
  PRINTER: "",
  PRINTER_ID: (id) => id,
};

export default printerPaths;
